import React from 'react';
import { useBuildInfo } from '../../hooks/useBuildInfo';
import { LoadingSpinner } from '../common/LoadingSpinner';

export const Footer: React.FC = () => {
  const { buildInfo, isLoading } = useBuildInfo();

  return (
    <footer className="w-full py-4 bg-primary-100 text-center text-sm text-gray-600">
      <div className="container mx-auto px-4">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
          <div className="text-gray-600 text-xs sm:text-sm">
            &copy; {new Date().getFullYear()} My Masjid Connect - Your Charitable giving made easy!
            All rights reserved.
          </div>
          {isLoading ? (
            <div className="hidden sm:flex items-center">
              <LoadingSpinner size="sm" />
            </div>
          ) : buildInfo ? (
            <div className="hidden sm:flex items-center gap-2 text-xs sm:text-sm">
              <span className="font-medium">Version {buildInfo.version}</span>
              <span className="text-gray-400">(Build #{buildInfo.build_number})</span>
            </div>
          ) : null}
        </div>
      </div>
    </footer>
  );
};
